<template>
  <div class="row">
    <nav-prijmy class="col-md-3 side-menu"/>
    <div class="col-md-9 col-editor col-editor-right">
      <rest-loading />
      <router-view name="pv"/>

      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
        crossorigin="anonymous">

    </div>
  </div>
</template>

<script>
import RestLoading from '@/components/RestLoading.vue';
import NavPrijmy from '@/nav/navPrijmy.vue';

export default {
  components: {
    RestLoading,
    NavPrijmy,
  },
};
</script>

<style>
 body {
     font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
     line-height: 1.42857143;
     font-size: 16px;
 }
 .list-group-item.active {
     background-color: #304862;
 }
 .list-group-item.active:hover, .list-group-item:hover {
    background-color: #3a5878;
    color: #fff;
     }
 .list-group-item {
    border: 0;
    font-size: 85%;
    text-transform: uppercase;
    border-radius: 2px;
    padding: 5px 35px;
    position: relative;
    display: block;
}
h1 {
    font-size: 1em;
    font-weight: bold;
    padding: 15px 0px;
    line-height: 1.1;
    margin-right: 1.1em;
    margin-left: 1%;
    border-left-color: inherit;
}
.side-menu {
    padding-right: 15px;
    padding-left: 15px;
    position: relative;
    min-height: 1px;
}
.card {
    border: 0px;
}
.svg-inline--fa.fa-pull-left {
    margin-right: 1.0em;
}
.otherPages {
    margin-left: 5%;
}
a {
    color:#3a5878;
}
a:hover {
  text-decoration: none;
}
</style>
